import deepEqual from 'deep-equal';

export function deepEqualExcludingKeys(a, b, keys) {
  const copyA = { ...a };
  const copyB = { ...b };
  for (const key of keys) {
    delete copyA[key];
    delete copyB[key];
  }
  return deepEqual(copyA, copyB);
}

export function deepEqualExcludingId(a, b) {
  return deepEqualExcludingKeys(a, b, ['id']);
}
